import { render, staticRenderFns } from "./listComponent.vue?vue&type=template&id=73f74508&scoped=true&"
import script from "./listComponent.vue?vue&type=script&lang=js&"
export * from "./listComponent.vue?vue&type=script&lang=js&"
import style0 from "./listComponent.vue?vue&type=style&index=0&id=73f74508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f74508",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VContainer,VIcon,VSpacer,VSwitch,VToolbar})


/* hot reload */
if (module.hot) {
  var api = require("/mnt/c/Users/tes028/source/Tesfri/logistic-variant-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73f74508')) {
      api.createRecord('73f74508', component.options)
    } else {
      api.reload('73f74508', component.options)
    }
    module.hot.accept("./listComponent.vue?vue&type=template&id=73f74508&scoped=true&", function () {
      api.rerender('73f74508', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/generic/list/listComponent.vue"
export default component.exports